var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.519,
    height: 13.178,
    viewBox: "0 0 156.519 13.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72044",
    "data-name": "Path 72044",
    d: "M-5834.349,3020.5s105.942-1.377,132.6,0,50.6,5.2-48.125,5.093-40.109,7.506,32.179,6.129",
    transform: "translate(5834.355 -3019.282)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingLine);
export default __webpack_public_path__ + "static/media/heading_line.0e67efc8.svg";
export { ForwardRef as ReactComponent };